import permissions from '../../permissions'

const PAYMENT_SERVICE_TEMPLATE_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.PAYMENT_SERVICE_TEMPLATES.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.PAYMENT_SERVICE_TEMPLATES.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.PAYMENT_SERVICE_TEMPLATES.EDIT,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.PAYMENT_SERVICE_TEMPLATES.DESTROY,
  },
]

export default PAYMENT_SERVICE_TEMPLATE_LIST
